import React, { useState } from "react";
import { connect } from "react-redux";
//import { CSVLink } from "react-csv";

import { testCaseTableColumnDefinitions } from "../data/testCaseTableColumnDefinitions";

import { clearTestCaseResults } from "../actions/testCaseActions.js";

import { fileNameForCSVDownload, truncate, searchParamsMapForDisplay, testCaseTableOptions } from "../data/constdata.jsx";

import {
  Table,
  TableFiltering,
  TableSorting,
  TablePagination,
  TableContentSelector,
  TablePreferences,
  Spinner,
  Button
} from "AWS-UI-Components-React";

import "../styles/test-case-table.css";

const TestCaseTable = (props) => {

  const { testCaseState } = props;

  const [resultCount, setResultCount] = useState(0);

  const handleTablePreferences = (e) => {
    localStorage.setItem("table-column-preferences", JSON.stringify(e.detail.contentSelection));
  };

  const emptyContent = (
    testCaseState.resultsLoading ? <Spinner /> : "No Test Cases to Show"
  );

  const QueryDisplay = () => {
    if (Object.keys(testCaseState.queryParameters).length === 0) {
      return <div className="awsui-util-label"><strong>No parameters entered - displaying all test cases</strong></div>;
    }
    return Object.keys(testCaseState.queryParameters).map(item => (
      <div className="awsui-util-label" key={item}>
        <strong>{searchParamsMapForDisplay[item]}:</strong> <span className="awsui-util-status-inactive">{truncate(testCaseState.queryParameters[item])}</span>
      </div>
    ));
  };

  const headerContent = (
    <div>
      <div className="header-content">
        <h2 className="header-content-item">Test Case Search Results</h2>
        <div className="header-content-item">
          {/* <DownloadButton /> */}
          <Button
            text="Clear Results"
            onClick={props.clearTestCaseResults}
          />
        </div>
      </div>
      {testCaseState.testCaseQueryCompleted &&
        <div>
          <div>Displaying results for query parameters: <QueryDisplay /></div>
          <div>______________</div> <div className="awsui-util-label">Item count: <strong>{resultCount}</strong></div>
        </div>}
    </div>
  );

  const handleFilteringTable = (int) => {
    setResultCount(int);
  };

  return (
    <div>
      <Table
        columnDefinitions={testCaseTableColumnDefinitions}
        items={testCaseState.testCaseResults}
        header={headerContent}
        empty={emptyContent}
        onContentSelectionChange={handleTablePreferences}
        resizableColumns={true}
      >
        <TableFiltering filteringCountTextFunction={handleFilteringTable} />
        <TablePagination pageSize={10} />
        <TableSorting />
        <TablePreferences
          confirmLabel="Set Table Columns"
          cancelLabel="Cancel"
        >
          <TableContentSelector
            title="Displayed Columns"
            options={testCaseTableOptions}
          />
        </TablePreferences>

      </Table>
    </div>
  );
};

const mapStateToProps = state => ({
  testCaseState: state.testCaseState
});

const mapDispatchToProps = dispatch => ({
  clearTestCaseResults: () => dispatch(clearTestCaseResults()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TestCaseTable);


// WEBPACK FOOTER //
// ./src/components/TestCaseTable.jsx